import type { FC } from 'react';
import { useGetEquipmentTypes } from '@views/screens/Shipment/hooks';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';

import FormSelectBox from '../../../../components/Inputs/FormSelectBox';

interface EquipmentTypeSelectProps extends Pick<FormItemProps, 'rules' | 'name'>, Pick<SelectProps, 'placeholder'> {
  label?: string;
  margin?: string;
  editMode?: boolean;
  onChange?: (value: unknown) => void;
  tooltip?: string;
  isDefault?: boolean;
  isRequired?: boolean;
}

export const EquipmentTypeSelect: FC<EquipmentTypeSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.equipmentType.placeholder'),
  label = i18n.t('translation:default.fields.equipmentType.label'),
  rules = [],
  name,
  margin,
  editMode = true,
  onChange,
  tooltip,
  isDefault = false,
  isRequired = false,
}) => {
  const { data: options = [], isLoading } = useGetEquipmentTypes();

  return (
    <FormSelectBox
      loading={isLoading}
      options={
        isDefault
          ? [{ label: i18n.t('translation:default.buttons.select'), value: '' }, ...options]
          : [{ label: i18n.t('translation:default.options.all'), value: -1 }, ...options]
      }
      placeholder={placeholder}
      label={label}
      margin={margin}
      isRequired={isRequired}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      tooltip={tooltip}
    />
  );
};
